module.exports = __webpack_public_path__ + "static/media/avatar47.69b42a0d.png";